import { render, staticRenderFns } from "./omt-app-page-content.vue?vue&type=template&id=045aa882&"
import script from "./omt-app-page-content.vue?vue&type=script&lang=js&"
export * from "./omt-app-page-content.vue?vue&type=script&lang=js&"
import style0 from "./omt-app-page-content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports